/**
 * Class for the storage of a saved course plan.
 */
class SavedCoursePlan {

   constructor(data) {

      this.courseId = null // e.g. "B1390v2"
      this.courseCode = null // e.g. "B1390"
      this.courseLoopVersion = null // e.g. "26"
      this.status = null // e.g. "Active" / "Draft"
      this.courseName = null // e.g. "Bachelor of Science"
      this.createdOn = null // e.g. 23/08/22, 10:06 am

      this.selectedPreferences = {}
      this.selectedPreferences.studentType = null
      this.selectedPreferences.placeOfResidence = null
      this.selectedPreferences.studyOption = null
      this.selectedPreferences.existingStudent = null
      this.selectedPreferences.commencementYear = null
      this.selectedPreferences.startYear = null
      this.selectedPreferences.teachingPeriod = null

      this.selectedMajors = []
      this.selectedMinors = []

      this.totalCreditPoints = 0
      this.selectedCreditPoints = 0
      this.selectedUnits = []
      this.completedUnits = []

      this.coursePlan = {}
   }
}


module.exports = SavedCoursePlan
